import Transparencia from "./CareerListingMinimal";

//export { default } from './CareerListingMinimal';

export default {
    path: '/transparencia',
    component: Transparencia
}